module.exports = __webpack_public_path__ + "assets/images/outfit-03.21c8488c8b0fb93f7d59f06be754ee1b.svg";